
import { defineComponent } from "vue";
import HeaderVue from "./components/header/Header.vue";
import FooterVue from "./components/footer/Footer.vue";
import "./assets/fonts/fonts.module.css";
import { ExerciseActions } from "./store/modules/exercise/types";
import { namespaceName } from "./store/createStore";
import MobileBannerVue from "./components/ui/MobileBanner.vue";

export default defineComponent({
  components: {
    appMobileBanner: MobileBannerVue,
    appHeader: HeaderVue,
    appFooter: FooterVue,
  },

  mounted() {
    this.$store.dispatch(
      namespaceName("exercise", ExerciseActions.ReadCachedPreferences)
    );
  },
});
